import {first, Subject, Subscription} from "rxjs";
import {Response} from "../interfaces/common.interface";

export class ViewTracker {

    private expectedNumber : number
    private loadedNumber = 0
    private treeLoadSource = new Subject<boolean>();
    private treeLoad = this.treeLoadSource.asObservable();
    private subscriptions : Subscription[] = [];

    constructor(expectedNumber: number = 1) {
        this.expectedNumber = expectedNumber;
    }

    public loaded(component: any) {
        this.loadedNumber += 1
        if(this.expectedNumber == this.loadedNumber) {
            this.treeLoadSource.next(true)
            this.loadedNumber = 0
        }
    }

    public subscribe(next: ((p: boolean) => void)) {
        this.subscriptions.push(this.treeLoad.pipe(first()).subscribe(next));
    }

    public clear() {
        this.subscriptions.forEach(s => {
            s.unsubscribe()
        })
    }

}

export enum CommandMode {
    VIEW = "view",
    EDIT = "edit",
    LIST = "list",
    NEW = "new",
}
export class Command<T> {

    private _object : Response<T>
    private _mode = CommandMode.VIEW
    private _created : boolean
    private _updated : boolean

    constructor(object: Response<T>, mode?: CommandMode, created : boolean = false, updated : boolean = false) {
        this._object = object;
        this._mode = mode;
        this._created = created;
        this._updated = updated;
    }

    get response(): Response<T> {
        return this._object
    }

    get success(): boolean {
        if(!this.result || !this.result.outcome)
            return true
        return this.result.outcome.success
    }

    get message(): string {
        if(this.result && this.result.outcome && this.result.outcome.message)
            return this.result.outcome.message
        return null
    }

    get result(): any {
        return this._object;
    }

    get object(): T | null {
        return this._object?.data;
    }

    get mode(): CommandMode {
        return this._mode;
    }

    set mode(value: CommandMode) {
        this._mode = value;
    }

    get editable(): boolean {
        return this.mode == CommandMode.EDIT || this.mode == CommandMode.NEW
    }

    get new(): boolean {
        return this.mode == CommandMode.NEW
    }

    get created(): boolean {
        return this._created;
    }

    get updated(): boolean {
        return this._updated;
    }

    toUpdated(): Command<T> {
        this._updated = true;
        this._created = false;
        return this;
    }

    public static forNew<T>(object : Response<T>) {
        return new Command(object, CommandMode.NEW)
    }

    public static forEdit<T>(object : Response<T>) {
        return new Command(object, CommandMode.EDIT)
    }

    public static created<T>(object : Response<T>) {
        return new Command(object, CommandMode.EDIT, true)
    }

    public static updated<T>(object : Response<T>) {
        return new Command(object, CommandMode.EDIT, false, true)
    }

    public static forView<T>(object : Response<T>) {
        return new Command(object, CommandMode.VIEW)
    }

    public static forList<T>(object : Response<T>) {
        return new Command(object, CommandMode.LIST)
    }
}







